import { useFrappeGetCall } from "frappe-react-sdk";

import type { FrappeMessage } from "../../lib/types";
import type { PublicOffer } from "../../features/landing/types";

export function usePublicOffer() {
  return useFrappeGetCall<FrappeMessage<PublicOffer>>(
    "ownerflow.api.marketing.get_public_offer",
    undefined,
    "marketing:public-offer",
  );
}
